<template>
  <div>

 
  <el-form
    :model="UserForm"
    :rules="rules"
    ref="ruleForm"
    label-width="120px"
    class="demo-ruleForm"
  >
  <el-form-item label="工号/学号" prop="id">
      <el-input v-model="UserForm.ghxh" style="width: 200px"></el-input>
    </el-form-item>
    <el-form-item label="姓名" prop="name">
      <el-input v-model="UserForm.name" style="width: 200px"></el-input>
    </el-form-item>
    <el-form-item label="手机号" prop="phone">
      <el-input v-model="UserForm.phone" style="width: 280px"></el-input>
    </el-form-item>
    <el-form-item label="身份证号" prop="idc">
      <el-input v-model="UserForm.idc" style="width: 350px"></el-input>
    </el-form-item>
    <el-form-item label="性别" prop="sex">
      <el-select v-model="UserForm.sex" placeholder="请选择性别">
        <el-option label="男" value="男"></el-option>
        <el-option label="女" value="女"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="人员分类" prop="fenlei">
      <el-select v-model="UserForm.fenlei" placeholder="请选择分类">
        <el-option
          v-for="(classification, index) in personnelClassifications"
          :key="index"
          :label="classification"
          :value="classification"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="创建时间" required>
      <el-col :span="5">
        <el-form-item prop="date1">
          <el-date-picker
            type="date"
            placeholder="选择日期"
            v-model="UserForm.date1"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
      </el-col>
      <el-col class="line" :span="2">-</el-col>
      <el-col :span="5">
        <el-form-item prop="date2">
          <el-time-picker
            placeholder="选择时间"
            v-model="UserForm.date2"
            style="width: 100%"
          ></el-time-picker>
        </el-form-item>
      </el-col>
    </el-form-item>
    <el-form-item label="人脸数据录入">
      <div class="face-capture">
        <video ref="video" width="320" height="240" autoplay></video>
        <canvas ref="canvas" style="display:none;"></canvas>
        <el-button-group>
          <el-button @click="startCamera" type="primary">开启摄像头</el-button>
          <el-button @click="captureFace" :disabled="!isCameraOn">拍摄照片</el-button>
        </el-button-group>
        <img v-if="UserForm.faceData" :src="UserForm.faceData" class="face-preview">
      </div>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="submitEdit">保存编辑</el-button>
      <el-button @click="resetForm">重置</el-button>
    </el-form-item>
  </el-form>
  <div >
      <footers/>
    </div>
</div>
</template>

<script>
import axios from "axios";
import footers from '../components/footer.vue'

export default {
  components: {
    footers
  },
  data() {
    return {
      // 在这里添加 isCameraOn 属性并设置初始值
      isCameraOn: false,
      UserForm: {
        ghxh: "",
        name: "",
        phone: "",
        idc: "",
        sex: "",
        fenlei: "",
        date1: "",
        date2: "",
        faceData: "" // 初始化人脸数据为空
      },
      personnelClassifications: [], // 存储人员分类列表
      rules: {
        ghxh: [
          { message: "请输入工号/学号", trigger: "blur" },
          {
            pattern: /^[a-zA-Z0-9]{6,20}$/,
            message: "工号/学号格式不正确",
            trigger: "blur",
          },
        ],
        name: [
          { message: "请输入姓名", trigger: "blur" },
          {
            pattern: /^[\u4e00-\u9fa5]{2,10}$/,
            message: "姓名格式不正确",
            trigger: "blur",
          },
        ],
        phone: [
          { message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "手机号格式不正确",
            trigger: "blur",
          },
        ],
        idc: [
          { message: "请输入身份证号", trigger: "blur" },
          {
            pattern:
              /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))((0[1-9])|([12][0-9])|3[01])\d{3}[Xx\d]$/,
            message: "身份证号格式不正确",
            trigger: "blur",
          },
        ],
        sex: [{ required: true, message: "请选择性别", trigger: "change" }],
        fenlei: [
          { required: true, message: "请选择人员分类", trigger: "change" },
        ],
        date1: [{ required: true, message: "请选择日期", trigger: "change" }],
        date2: [{ required: true, message: "请选择时间", trigger: "change" }],
      },
    };
  },
  created() {
    // 假设这里通过路由参数获取要编辑的用户信息
    const userId = this.$route.params.id;
    this.$http.get(`UserForm/${userId}`)
      .then((res) => {
        this.UserForm = res;
      })
      .catch((err) => {
        console.error("获取用户信息失败:", err);
        this.$message.error("获取用户信息失败，请重试");
      });
  },
  methods: {
    async startCamera() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true });
        this.$refs.video.srcObject = stream;
        this.isCameraOn = true;
      } catch (error) {
        this.$message.error('摄像头访问失败');
      }
    },
    captureFace() {
      const video = this.$refs.video;
      const canvas = this.$refs.canvas;
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      
      const ctx = canvas.getContext('2d');
      ctx.drawImage(video, 0, 0);
      
      // 压缩图片质量并转为Base64
      this.UserForm.faceData = canvas.toDataURL('image/jpeg', 0.7);
      this.$message.success('人脸数据已捕获');
      
      // 关闭摄像头
      video.srcObject.getTracks().forEach(track => track.stop());
      this.isCameraOn = false;
    },
    submitEdit() {
      const userId = this.$route.params.id;
      this.$http.put(`UserForm/${userId}`, this.UserForm)
        .then((res) => {
          console.log('请求成功，响应数据:', res); // 打印完整的响应对象
          this.$message({
            message: "人员编辑成功",
            type: "success",
          });
          this.$router.push('/user/list');
        })
        .catch((err) => {
          console.error("编辑人员失败:", err);
          this.$message.error("编辑人员失败，请重试");
        });
    },
    resetForm() {
      this.UserForm.ghxh = ''; // 重置学号/工号
      this.$refs.ruleForm.resetFields();
      this.UserForm.faceData = ""; // 重置人脸数据
      this.isCameraOn = false; // 重置摄像头状态
      const video = this.$refs.video;
      if (video.srcObject) {
        video.srcObject.getTracks().forEach(track => track.stop());
        video.srcObject = null;
      }
    }
  }
};
</script>
